import type { ReactNode } from 'react';
import type { UseMutationResult } from 'react-query';
import { useModal } from '../hooks/useModal';
import type { ApiResponse } from '../util/types/Response';
import { SmallModal } from './SmallModal';

interface DeleteModalProps {
	close: () => void;
	isOpened: boolean;
	titleType: string;
	itemDescription: string;
	extraInfo?: ReactNode;
	mutation: UseMutationResult<ApiResponse<any>, unknown, void, unknown>;
	onComplete: () => void;
}

export function DeleteModal({
	close,
	isOpened,
	titleType,
	itemDescription,
	onComplete,
	extraInfo,
	mutation,
}: DeleteModalProps) {
	const completeModal = useModal();

	return (
		<>
			<SmallModal
				isOpen={isOpened}
				close={close}
				title={`Delete ${titleType}`}
				body={
					<>
						Are you sure you want to delete <i>{itemDescription}</i>?&nbsp;
						Click OK to confirm...
						{extraInfo && (
							<>
								<br />
								<br />
								{extraInfo}
							</>
						)}
					</>
				}
				onComplete={async () => {
					close();
					await mutation.mutateAsync().then(() => completeModal.open());
				}}
			/>
			<SmallModal
				isOpen={completeModal.isOpen}
				close={() => {
					onComplete();
					completeModal.close();
				}}
				title={'Delete Complete'}
				body={
					<>
						Deletion of <i>{itemDescription}</i> has successfully completed.
						Click OK to continue...
					</>
				}
			/>
		</>
	);
}
